import { createSlice } from "@reduxjs/toolkit";
import { login, getProfile } from "../controller/auth.controller";
import { LoginResponse, Profile } from "../types/authType";

interface AuthState {
  loading: boolean;
  loginResponse: LoginResponse | null;
  profile: Profile | null;
  error: string | null;
}

const initialState: AuthState = {
  loading: false,
  loginResponse: null,
  profile: null,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetLoginResponse: (state) => {
      state.loginResponse = null;
    },
    clearAuth: (state) => {
      state.profile = null;
      state.loginResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.loginResponse = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Login gagal";
      })
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.data ?? null;
      })
      .addCase(getProfile.rejected, (state) => {
        state.loading = false;
        state.profile = null;
      });
  },
});

export const { resetLoginResponse, clearAuth } = authSlice.actions;
export default authSlice.reducer;
